/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MODERATOR" | "STAFF" | "%future added value";
export type UserRoleChangeContainer_viewer = {
    readonly id: string;
    readonly role: USER_ROLE;
    readonly moderationScopes: {
        readonly scoped: boolean;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SiteModeratorActions_viewer">;
    readonly " $refType": "UserRoleChangeContainer_viewer";
};
export type UserRoleChangeContainer_viewer$data = UserRoleChangeContainer_viewer;
export type UserRoleChangeContainer_viewer$key = {
    readonly " $data"?: UserRoleChangeContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"UserRoleChangeContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserRoleChangeContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "UserModerationScopes",
            "kind": "LinkedField",
            "name": "moderationScopes",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scoped",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SiteModeratorActions_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '1a14d5ac22488ffccad317aa4fc56443';
export default node;
